// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ui-dialog {
  z-index: 1000000 !important;
}

#rc-panel-holder {
  z-index: 99999;
  width: calc(100% - 2rem);
  margin: 0 1rem;
}

#rc-language-label {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}

#rc-language {
  position: fixed;
  top: 2rem;
  left: 2rem;
}

#lang-picker {
  font-size: 1.2rem;
  padding: 3px;
}

.rsvpReadingTargetWordsKey {
  display: flex;
  flex-direction: row;
  position: absolute;
  top: 2.5vh;
  left: 1vw;
  z-index: 9999999;

  font-size: 2em;
}

.rsvpReadingTargetWord {
  padding: 20px;
}
.hidden {
  visibility: hidden;
}

.rsvpReadingTargetWordCurrent {
  text-decoration: underline;
  background: none;
}

.simulated-cover {
  height: 100vh;
  width: 100vw;
  z-index: 99999999999999999;
  pointer-events: none;
  background-color: lightgrey;
  opacity: 95%;
  position: absolute;
  top: 0;
  left: 0;
}
.simulated-ring {
  border: important 15px solid coral;
}
`, "",{"version":3,"sources":["webpack://./components/css/custom.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE;gEAC8D;AAChE;;AAEA;EACE,eAAe;EACf,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,gBAAgB;;EAEhB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,0BAA0B;EAC1B,oBAAoB;EACpB,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;AACA;EACE,kCAAkC;AACpC","sourcesContent":[".ui-dialog {\n  z-index: 1000000 !important;\n}\n\n#rc-panel-holder {\n  z-index: 99999;\n  width: calc(100% - 2rem);\n  margin: 0 1rem;\n}\n\n#rc-language-label {\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen,\n    Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n}\n\n#rc-language {\n  position: fixed;\n  top: 2rem;\n  left: 2rem;\n}\n\n#lang-picker {\n  font-size: 1.2rem;\n  padding: 3px;\n}\n\n.rsvpReadingTargetWordsKey {\n  display: flex;\n  flex-direction: row;\n  position: absolute;\n  top: 2.5vh;\n  left: 1vw;\n  z-index: 9999999;\n\n  font-size: 2em;\n}\n\n.rsvpReadingTargetWord {\n  padding: 20px;\n}\n.hidden {\n  visibility: hidden;\n}\n\n.rsvpReadingTargetWordCurrent {\n  text-decoration: underline;\n  background: none;\n}\n\n.simulated-cover {\n  height: 100vh;\n  width: 100vw;\n  z-index: 99999999999999999;\n  pointer-events: none;\n  background-color: lightgrey;\n  opacity: 95%;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n.simulated-ring {\n  border: important 15px solid coral;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
